import { useEffect, useState } from 'react';
import {
  getMaxUsersInWorkspace,
  getWorkspaceUsers,
  IWorkspace,
  getClientAssignedUser,
  getAssignedUserForClientContact,
  getInvitedUsersInWorkspaceList,
} from 'wisestep-api';

export const useTotalInvitesCall = () => {
  const [maxInvites, setMaxInvites] = useState<number>(0);

  const loadCurrentWorkspaceData = async () => {
    const response = await getMaxUsersInWorkspace(['RS_MAX_USERS']);
    setMaxInvites(response.data.RS_MAX_USERS);
  };

  useEffect(() => {
    loadCurrentWorkspaceData();
  }, []);

  return [maxInvites];
};

export const useInvitedUsers = () => {
  const [invitedUsers, setInvitedUsers] = useState<IWorkspace[]>([]);

  const loadInvitedUsersData = async () => {
    const response = await getInvitedUsersInWorkspaceList();
    setInvitedUsers(response.data);
  };

  useEffect(() => {
    loadInvitedUsersData();
  }, []);

  return invitedUsers;
};

export const fetchAndSetAssignedUsers = async (loggedInUser: string) => {
  try {
    const response = await getWorkspaceUsers({
      roles: [],
      statuses: ['activated'],
      userIds: [loggedInUser || ''],
      page: 0,
      size: 20,
      id: '',
    });

    return response.data.workspaceUsers?.[0]?.assignedUsers || [];
  } catch (error) {
    console.error('Error fetching assigned users:', error);
    return [];
  }
};

export const getUserNameByIdInWorkspaceUsers = async (userIds: string[]) => {
  try {
    const response = await getWorkspaceUsers({
      roles: [],
      statuses: ['activated'],
      userIds,
      page: 0,
      size: userIds.length,
    });

    return response.data.workspaceUsers.reduce((map, user) => {
      if (user.userId) map[user.userId] = user.userName || '';
      return map;
    }, {} as Record<string, string>);
  } catch (error) {
    console.error('Error fetching workspace users:', error);
    return {};
  }
};

const getFilteredAssignedUsers = async (fetchUsersFunction, identifier) => {
  try {
    const [assignedUsersResponse] = await Promise.all([fetchUsersFunction(identifier)]);

    return assignedUsersResponse.data;
  } catch (error) {
    console.error('Error filtering assigned users:', error);
    return [];
  }
};

export const getActiveWorkspaceUsers = (clientId) =>
  getFilteredAssignedUsers(getClientAssignedUser, clientId);

export const getClientContactActiveWorkspaceUsers = (clientShareDTO) =>
  getFilteredAssignedUsers(getAssignedUserForClientContact, clientShareDTO);
